export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) {
    return
  }
})
